<template>
    <div v-if="profile" class="gmf-profile-card gmf-context">
  
      <div class="gmf-profile-business-card">
        <div class="gmf-profile-identity">
          <div class="gmf-profile-avatar-col">
            <a v-if="config.avatarEditorUrl" :href="config.avatarEditorUrl" class="gmf-profile-avatar">
              <object class="gmf-avatar" type="image/svg+xml" :data="avatarUrl"></object>
            </a>
            <div v-else class="gmf-profile-avatar">
              <object class="gmf-avatar" type="image/svg+xml" :data="avatarUrl"></object>
            </div>
            <div class="gmf-profile-name gmf-subheader" v-text="name || t('my_profile')"/>
          </div>
          <div class="gmf-profile-stats">
            <table>
              <tbody>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_achievements"></td>
                  <td class="gmf-profile-stat-number">{{ profile.unlockedAchievementCount }}</td>
                  <td class="gmf-profile-stat" v-text="t('stat_achievements')"></td>
                </tr>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_comments"></td>
                  <td class="gmf-profile-stat-number">{{ commentCount }}</td>
                  <td class="gmf-profile-stat" v-text="t('stat_comments')"></td>
                </tr>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_likes"></td>
                  <td class="gmf-profile-stat-number">{{ likeCount }}</td>
                  <td class="gmf-profile-stat" v-text="t('stat_likes')"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="gmf-profile-level-container">
          <div class="gmf-profile-level-text">
            <span class="gmf-profile-level">{{t('level')}} {{ profile.customerLevel }}</span>
            <span class="gmf-profile-level-name gmf-customer-title" v-if="profile.levelName">{{ profile.levelName }}</span>
            <div class="gmf-profile-xp-text gmf-xp">{{ profile.xp }} / {{ profile.xpToNextLevel }}{{ state.t('xp') }}</div>
          </div>
          <div class="gmf-profile-level-bar-outer"><div class="gmf-profile-level-bar-inner" :style="{ width: barWidth }"></div></div>
        </div>
      </div>
  
      <div class="gmf-profile-business-card-stats-and-event-cards">
        <div class="gmf-profile-identity">
          <div class="gmf-profile-avatar-col">
            <a v-if="config.avatarEditorUrl" :href="config.avatarEditorUrl" class="gmf-profile-avatar">
              <img :src="avatarUrl" />
            </a>
            <div v-else class="gmf-profile-avatar">
              <img :src="avatarUrl" />
            </div>
            <div class="gmf-profile-name gmf-subheader" v-text="name || t('my_profile')"/>
          </div>
          <div class="gmf-profile-stats">
            <table>
              <tbody>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_achievements"></td>
                  <td class="gmf-profile-stat-number">{{ profile.unlockedAchievementCount }}</td>
                </tr>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_comments"></td>
                  <td class="gmf-profile-stat-number">{{ commentCount }}</td>
                </tr>
                <tr>
                  <td><img class="gmf-profile-stat-icon" :src="config.icons.stats_likes"></td>
                  <td class="gmf-profile-stat-number">{{ likeCount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="gmf-profile-business-card-cards-col">
            <div class="gmf-subheader" v-if="t('event_cards.header')" v-text="t('event_cards.header')"/>
            <div class="gmf-profile-business-card-cards">
              <div v-for="lc in lootCrates" :key="lc.typeName" class="gmf-profile-event-card gmf-clickable" @click="openLootCrate(lc)" :title="lc.label">
                <img :src="lc.imageUrl" />
              </div>
  
              <div
                class="gmf-profile-event-card gmf-clickable"
                v-for="achievement in achievements"
                :key="achievement.id"
                @click="showAchievementDetails(achievement)"
                >
                <!-- staticImageUrl being set means that imageUrl is animated -->
                <object
                  v-if="achievement.staticImageUrl"
                  :data="achievement.imageUrl"
                  :title="achievement.name"
                  type="image/svg+xml"
                />
                <img
                  v-else
                  :src="achievement.imageUrl"
                  :title="achievement.name"
                />
              </div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
              <div class="gmf-profile-event-card"></div>
            </div>
          </div>
        </div>
        <div class="gmf-profile-level-container">
          <div class="gmf-profile-level-text">
            <span class="gmf-profile-level">{{ t('level') }} {{ profile.customerLevel }}</span>
            <span class="gmf-profile-level-name gmf-customer-title" v-if="profile.levelName">{{ profile.levelName }}</span>
            <div class="gmf-profile-xp-text">{{ profile.xp }} / {{ profile.xpToNextLevel }}{{ state.t('xp') }}</div>
          </div>
          <div class="gmf-profile-level-bar-outer"><div class="gmf-profile-level-bar-inner" :style="{ width: barWidth }"></div></div>
        </div>
      </div>
  
  
      <div class="gmf-profile-module-event-cards-large">
        <div class="gmf-profile-event-container">
          <div v-for="lc in lootCrates" :key="lc.typeName" class="gmf-profile-event-card gmf-clickable" @click="openLootCrate(lc)" :title="lc.label">
            <div class="gmf-subheader" v-if="t('event_cards.new_loot_crate')" v-text="t('event_cards.new_loot_crate')"></div>
            <div class="gmf-profile-event-card-img">
              <img :src="lc.imageUrl" />
            </div>
            <!--<div class="gmf-profile-loot-crate-count">{{ lc.quantity }}</div>-->
          </div>
  
          <div
            class="gmf-profile-event-card gmf-clickable"
            v-for="achievement in achievements"
            :key="achievement.id"
            @click="showAchievementDetails(achievement)"
            >
            <div class="gmf-subheader" v-if="t('event_cards.new_achievement')" v-text="t('event_cards.new_achievement')"></div>
            <!-- staticImageUrl being set means that imageUrl is animated -->
            <div class="gmf-profile-event-card-img">
              <object
                v-if="achievement.staticImageUrl"
                :data="achievement.imageUrl"
                :title="achievement.name"
                type="image/svg+xml"
              />
              <img
                v-else
                :src="achievement.imageUrl"
                :title="achievement.name"
              />
            </div>
            <div class="gmf-text">{{ achievement.name }}</div>
            <div class="gmf-xp" v-if="achievement.rewards.xp">{{ achievement.rewards.xp }}{{ state.t('xp') }}</div>
          </div>
  
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
        </div>
      </div>
  
      <!--
      <div class="gmf-profile-module-event-cards-small">
        <div class="gmf-profile-event-container">
          <div v-for="lc in lootCrates" :key="lc.typeName" class="gmf-profile-event-card gmf-clickable" @click="openLootCrate(lc)" :title="lc.label">
            <img :src="lc.imageUrl" />
          </div>
  
          <div
            class="gmf-profile-event-card gmf-clickable"
            v-for="achievement in achievements"
            :key="achievement.id"
            >
            <img
              :src="achievement.imageUrl"
              :title="achievement.name"
              @click="showAchievementDetails(achievement)"
            />
          </div>
  
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
          <div class="gmf-profile-event-card" />
        </div>
      </div>
    -->
  
  
    </div>
    <div v-else>{{state.t('loading')}}</div>
  </template>
  
  <style>
  .gmf-profile-event-card img, .gmf-profile-event-card object {
    filter: drop-shadow(0px 1px 1px rgba(0,0,0,.4));
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: 0;
    pointer-events: none;
  }
  
  
  .gmf-profile-card {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gmf-object-spacing);
  }
  
  .gmf-profile-card * {
    box-sizing: border-box; /* @TODO move to gmf-ctx */
  }
  
  /* Old style business card */
  .gmf-profile-business-card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: var(--gmf-p-3);
    align-items: stretch;
    min-width: 280px;
  }
  
  /* New compact style business card */
  .gmf-profile-business-card-stats-and-event-cards {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: var(--gmf-p-3);
    align-items: stretch;
    width: 280px;
  }
  
  .gmf-profile-avatar-col {
    display: flex;
    flex-direction: column;
    width: 120px;
    flex-shrink: 0;
  }
  
  
  /* Event cards */
  .gmf-profile-module-event-cards-large {
    display: flex;
    flex-grow: 10;
    position: relative;
    min-width: 250px;
    min-height: 200px;
  }
  
  .gmf-profile-module-event-cards-small {
    display: none;
    display: flex;
    flex-grow: 10;
    position: relative;
    min-width: 200px;
    min-height: 180px;
  }
  
  .gmf-profile-module-event-cards-small .gmf-profile-event-card img, .gmf-profile-module-event-cards-small .gmf-profile-event-card object {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: 0;
  }
  
  .gmf-profile-event-container {
    display: flex;
    gap: var(--gmf-object-spacing);
    position: absolute;
    inset: 0;
    overflow: hidden;
    flex-wrap: wrap;
  }
  .gmf-profile-event-card {
    background: var(--gmf-col-lightgray);
    border-radius: var(--gmf-rounding);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-grow: 1;
    flex-basis: 0;
    height: 100%;
    min-width: 150px;
    padding: var(--gmf-p-3);
  }
  .gmf-profile-event-card .gmf-text {
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
  }
  
  .gmf-profile-module-event-cards-small .gmf-profile-event-card {
    height: calc(50% - var(--gmf-object-spacing) * 0.5);
    min-width: 80px;
  }
  
  .gmf-profile-module-event-cards-large .gmf-profile-event-card-img {
    width: 80px;
    height: 80px;
    position: relative;
    margin: var(--gmf-p-3);
  }
  .gmf-profile-module-event-cards-large .gmf-profile-event-card object, .gmf-profile-module-event-cards-large .gmf-profile-event-card img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  
  .gmf-profile-identity {
    display: flex;
    gap: var(--gmf-object-spacing);
    flex-grow: 1;
    height: 148px;
  }
  .gmf-profile-avatar {
    width: 100%;
    display: block;
    position: relative;
  }
  .gmf-profile-avatar object {
    width: 100%;
  }
  
  
  
  .gmf-profile-stats {
    display: flex;
    align-items: center;
    flex: 2;
  }
  .gmf-profile-stat {
    vertical-align: middle;
    width: 100%;
    padding-left: var(--gmf-p-2);
    white-space: nowrap;
  }
  .gmf-profile-stats table {
    min-width: 100%;
  }
  .gmf-profile-stats td {
    font-size: var(--gmf-default-font-size);
  }
  .gmf-profile-stats tr:not(:last-child) td {
    padding-bottom: var(--gmf-p-4);
  }
  
  .gmf-profile-stat-icon {
    width: 22px;
    height: 22px;
    max-width: unset;
    vertical-align: middle;
    margin-right: var(--gmf-p-2);
    display: inline-block;
  }
  .gmf-context td.gmf-profile-stat-number {
    padding-right: var(--gmf-p-4);
    padding-left: var(--gmf-p-1);
    text-align: left;
    font-weight: bold;
    vertical-align: middle;
    font-weight: bold !important;
    white-space: nowrap;
  }
  
  
  
  
  .gmf-profile-business-card-cards-col {
    display: flex;
    flex-direction: column;
  }
  
  
  .gmf-profile-business-card-cards {
    display: flex;
    gap: var(--gmf-object-spacing);
    flex-wrap: wrap;
    flex-grow: 1;
    overflow: hidden;
  }
  .gmf-profile-business-card-cards .gmf-profile-event-card {
    flex-grow: 1;
    background: var(--gmf-col-lightgray);
    border-radius: var(--gmf-rounding);
    padding: var(--gmf-p-3);
    height: calc(50% - var(--gmf-object-spacing) / 2);
    min-width: 50px;
    display: flex;
  }
  
  
  .gmf-profile-level-container {
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
  }
  
  
  
  .gmf-profile-xp-text {
    float: right;
  }
  
  .gmf-profile-name {
    margin-top: var(--gmf-p-2) !important;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-bottom: 0 !important;
  }
  
  .gmf-profile-level-name {
    margin-left: var(--gmf-p-3);
  }
  
  
  
  /* Old stuff */

  .gmf-profile-level-bar-outer {
    height: 24px;
    margin: 0;
    background: var(--gmf-col-lightgray);
    padding: var(--gmf-p-2);
    border-radius: var(--gmf-rounding);
  }
  .gmf-profile-level-bar-inner {
    background: var(--gmf-brand-color);
    height: 100%;
    margin: 0;
    padding: 0;
    border-radius: var(--gmf-rounding);
    min-width: 3%;
  }
  .gmf-profile-level-text {
    padding: 0 var(--gmf-p-2);
    padding-bottom: var(--gmf-p-2);
  }
  
  
  .gmf-profile-event-card.gmf-clickable {
    cursor: pointer;
    transition: background 0.15s ease-out;
  }
  .gmf-profile-event-card.gmf-clickable:hover {
    background: var(--gmf-col-gray);
  }
  .gmf-profile-event-card.gmf-clickable img {
    transform-origin: center;
    transition: transform 0.15s ease-out;
  }
  .gmf-profile-event-card.gmf-clickable:hover img {
    transform: scale(1.1) rotate(2deg);
  }
  
  .gmf-profile-event-card .gmf-subheader {
    margin: 0 !important;
  }
  
  
  
  /* Mobile/Desktop switching */
  .gmf-profile-business-card-stats-and-event-cards {
    display: none;
  }
  @media (max-width: 600px) {
    .gmf-profile-business-card-stats-and-event-cards {
      display: flex;
    }
    .gmf-profile-business-card {
      display: none;
    }
    .gmf-profile-module-event-cards-large {
      display: none;
    }
  }
  
  </style>
  
  <script>
  import modal from '@/utils/modal';
  import state from '@/state';
  import callApi from '@/utils/callApi';
  import showAchievementDetails from '@/widgets/AchievementDetails/popup';
  import createLootCratesModal  from '@/widgets/LootCrate/createLootCratesModal';
  import mergeDeep from '@/utils/mergeDeep';
  import eventbus from '@/utils/eventbus';
  import { createAvatarConfigurator } from '@/legacy/avatar-configurator';
  
  const t = state.t.prefix('profile_card');
  
  export default {
    name: 'ProfileCard',
    data () {
      return {
        state,
  
        achievements: [],
        lootCrates: [],
        commentCount: 0,
        likeCount: 0,
  
        customerId: null,
        config: {
          icons: {
            stats_achievements: 'https://cdn.gamifiera.com/static/icons/achievements.svg',
            stats_comments: 'https://cdn.gamifiera.com/static/icons/comments.svg',
            stats_likes: 'https://cdn.gamifiera.com/static/icons/likes.svg',
          },
          achievementPageUrl: null,
          avatarEditorUrl: null,
          noLootIcon: null,
        },
        name: null,
  
        profile: null,
      };
    },
    mounted () {
      eventbus.on('avatar:update', this.onAvatarUpdate);
      // this.load();
      this.config.achievementPageUrl = state.merchantConfig.profileCard.achievementPageUrl;
      this.config.avatarEditorUrl = state.merchantConfig.profileCard.avatarEditorUrl;
      this.config.noLootIcon = state.merchantConfig.profileCard.noLootIcon;
  
      const icons = state.merchantConfig.profileCard.icons;
      if (icons) {
        for (const key in icons) {
          this.config.icons[key] = icons[key];
        }
      }
    },
    unmounted () {
      eventbus.off('avatar:update', this.onAvatarUpdate);
    },
    watch: {
      customerId (cid, oldCid) {
        if (cid === oldCid) {
          return;
        }
        this.load();
      },
    },
    computed: {
      avatarUrl () {
        if (this.profile.avatarUrl) {
          return this.profile.avatarUrl;
        }
        return this.state.cdnBase + '/v1/avatar/render/' + this.profile.avatarCode;
      },
      barWidth () {
        const currentXp = this.profile.xp - this.profile.xpToCurrentLevel;
        const toNextLevel = this.profile.xpToNextLevel - this.profile.xpToCurrentLevel;
        return (currentXp * 100 / toNextLevel).toFixed(2)+'%';
      },
    },
    methods: {
      openAvatarConfigInModal () {
        const m = modal.create();
  
        createAvatarConfigurator({
          selector: m.body,
        });
      },
      onAvatarUpdate (avatarCode) {
        if (this.profile) {
          this.profile.avatarCode = avatarCode;
        }
      },
      t,
      handleEvent (eventName) {
        if (this.config.on && this.config.on[eventName]) {
          return this.config.on[eventName]();
        }
        return true;
      },
      openLootCrate () {
        createLootCratesModal()
      },
      showAchievementDetails, // @TODO only shows your own progress
      applyConfig (config) {
        this.config = mergeDeep(JSON.parse(JSON.stringify(this.config)), config);
        this.customerId = config.customerId;
        this.name = config.name;
      },
      load () {
        if (this.customerId) {
          console.error('Cannot view other profiles');
          return;
        }
        callApi('GET', '/v1/client/my-profile')
        .then(res => {
          if (res.status == 401) {
            this.handleEvent('session_expired') && modal.error(t('session_expired'));
            return;
          }
          res.json().then(data => {
            // this.isLoading = false;
            this.profile = data;
  
            if (! this.name) {
              this.name = this.profile.name;
            }
          });
        });
  
        this.achievements = [];
        callApi('GET', '/v1/client/customer-achievements?sort=latest_unlocked&take=10&filter=unlocked&stack_unlocked')
        .then(res => {
          if (res.status == 401) {
            return;
          }
          res.json().then(data => {
            // this.isLoading = false;
            this.achievements = data.achievements;
          });
        });
  
  
        this.lootCrates = [];
        // @TODO only if we're on our own profile page
        callApi('GET', '/v1/client/my-loot-crates')
        .then(res => {
          if (res.status == 401) {
            return;
          }
          res.json().then(data => {
            // this.isLoading = false;
            this.lootCrates = data.lootCrates;
          });
        });
  
        this.commentCount = 0;
        this.likeCount = 0;
        callApi('GET', '/v1/client/my-comments?take=1000') // @TODO does not work for other customers profiles
        .then(res => {
          if (res.status == 401) {
            return;
          }
          res.json().then(data => {
            this.commentCount = data.totalCount;
            for (const comment of data.comments) {
              this.likeCount += comment.upvoteCount;
            }
          });
        });
      },
    },
  };
  
  </script>
  
